<script setup>
    import { ref, onMounted, computed } from 'vue';
    import Client from '../services/client';
    import Helpers from '../utils/helpers';

    const POST_PER_PAGE = 3;

    const props = defineProps({
        recentVideos: {
            type: Array,
            default: [],
        }
    });

    const postCount = ref(POST_PER_PAGE);
    const videos = ref([]);
    const showButtonLoadMore = ref(true);

    const mapVideos = computed(() => {
      return (videos.value || []).map((video) => {
        const videoCategories = video.taxonomies['video-category'];
        const isSponsored = (videoCategories || []).findIndex((videoCategory) => videoCategory.slug === 'sponsored-content') > -1;

        return {
          ...video,
          isSponsored,
        }
      })
    })

    onMounted(() => {
      fetchVideos();
    });

    const fetchVideos = async () => {
        const fetchData = {
            page: 1,
            per_page: postCount.value,
        };

        try {
            const { data, headers } = await Client.get(`/wp-json/wp/v2/video/?${Helpers.encodeGetParams(fetchData, true)}`, {
            headers: {'X-WP-Nonce': window.wp_nonce.nonce}
            });
            videos.value = data;

            if (headers['x-wp-total'] <= data.length) {
                showButtonLoadMore.value = false
            }
        } catch (e) {
            console.error(e);
        } finally {
            // loading
        }
    }

    const loadMore = () => {
        postCount.value += POST_PER_PAGE;
        fetchVideos();
    }

</script>

<template>
    <div v-for="recentVideo in mapVideos" class="recent-video">
        <a :href="recentVideo.link"
            class="recent-video"
        >
            <div :class="['recent-video__preview', {'sponsored-border': recentVideo.isSponsored}]" v-html="recentVideo.meta.video" />
            <span class="recent-video__title" v-html="recentVideo.title.rendered"></span>
            <span
                v-if="recentVideo.isSponsored"
                class="post-sponsored"
            >
              <img src="/dist/img/ico_sponsored.svg" alt="ico-sponsored">
              Sponsored content
            </span>
        </a>
    </div>
    <div class="more-recent-videos more-videos">
        <button v-show="showButtonLoadMore" @click.prevent="loadMore" class="btn load-more"><span>Load more videos</span></button>
    </div>
</template>
